export default "/images/eff1eff6b308d5abd18cda191543f633.avif";